import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AttachSkuOptionRequestModel } from 'src/models/requestModels/V2/option/AttachSkuOptionRequestModel';
import { UpdateSkuOptionRequestModel } from 'src/models/requestModels/V2/option/UpdateSkuOptionRequestModel';
import { DeleteSkuOptionRequestModel } from 'src/models/requestModels/V2/option/DeleteSkuOptionRequestModel'
import { SkuOption } from 'src/models/DTO/V2/skuOptions/SkuOption';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SkuoptionService {

  private optionBaseURL: string = environment.api + 'sku/option/';
  private optionAttachURL: string = this.optionBaseURL + 'attach';
  private optionDetachURL: string = this.optionBaseURL + 'detach';



  constructor(private httpClient: HttpClient) { }

  attachOptionToSku(attachSkuOptionRequestModel: AttachSkuOptionRequestModel): Observable<object> {
    return this.httpClient.post(this.optionAttachURL, attachSkuOptionRequestModel);
  }

  updateSkuOption(updatedSkuOption: UpdateSkuOptionRequestModel, skuOptionUIID: string): Observable<SkuOption> {
    return this.httpClient.put<SkuOption>(this.optionBaseURL + skuOptionUIID, updatedSkuOption);
  }

  deleteSkuOption(deleteSkuOption: DeleteSkuOptionRequestModel): Observable<any> {
    return this.httpClient.post<any>(this.optionDetachURL, deleteSkuOption);
  }

  getOptionsForSku(skuUUID: string): Observable<any> {
    return this.httpClient.get<SkuOption>(this.optionBaseURL + skuUUID);
  }
}
